import * as hpServicesApi from "../../api/healthPlanServicesApi";
import * as types from "../../constants/actionTypes";
import { call, put, select } from "redux-saga/effects";
import { logAPI } from "../../api/andyliticsApi";

export function* getGroupedProcedures(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);

    if (stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.EstimatorApi.getGroupedProcedures, domainData.t, params.MemberNumber);
            logAPI("MBHWeb.Saga.HealthPlanServices.Estimator.GetGroupedProcedures.Get", start, null);
            yield put({ type: types.HP_GET_GROUPED_PROCEDURES_SUCCESS, groupedProcedures: response, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Estimator.GetGroupedProcedures.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_GROUPED_PROCEDURES_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Estimator.GetGroupedProcedures.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}
export function* getGroupedProceduresByCPT(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);

    if (stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.EstimatorApi.getGroupedProceduresByCPT, domainData.t, params.MemberNumber);
            logAPI("MBHWeb.Saga.HealthPlanServices.Estimator.GetGroupedProceduresByCPT.Get", start, null);
            yield put({ type: types.HP_GET_GROUPED_PROCEDURES_BY_CPT_SUCCESS, cptProcedures: response, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Estimator.GetGroupedProcedures.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_GROUPED_PROCEDURES_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Estimator.GetGroupedProcedures.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getProcedureCost(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);

    if (stateData.aalDown === false) {
        try {
            let response;
            response = yield call(hpServicesApi.EstimatorApi.getProcedureCostValues2, domainData.t, params.MemberNumber,
                params.GroupDescript);
            
            
            logAPI("MBHWeb.Saga.HealthPlanServices.Estimator.GetProceduresCost.Get", start, null);

            let groupDescript = params.GroupDescript?.group_descript;
            console.log(groupDescript);
            let codes = groupDescript.split('|');
            let cptCode = null;
            if (codes.length > 1) {
                groupDescript = codes[0];
                cptCode = codes[1].trim();
                console.log(groupDescript);
                console.log(cptCode);
            }
            const copayValue = response.COPAY == undefined ? response.copay : response.COPAY;
            const coinsuranceValue = response.COINSURANCE == undefined ? response.coinsurance : response.COINSURANCE;
            const hasDeductibleValue = response.HAS_DEDUCTIBLE == undefined ? response.haS_DEDUCTIBLE : response.HAS_DEDUCTIBLE;
            const deductibleRemainingValue = response.DEDUCTIBLE_REMAINING == undefined ? response.deductiblE_REMAINING : response.DEDUCTIBLE_REMAINING ;
            const oopRemainingValue = response.OOP_REMAINING == undefined ? response.ooP_REMAINING : response.OOP_REMAINING;

            const costResponse = yield call(hpServicesApi.EstimatorApi.getProceduresCost, domainData.t, params.ProcedureId,
                params.GroupDescript?.group_descript, cptCode, copayValue, coinsuranceValue, hasDeductibleValue, deductibleRemainingValue,
                oopRemainingValue);
            yield put({ type: types.HP_GET_PROCEDURE_COST_SUCCESS, procedureCost: costResponse, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Estimator.GetGroupedProcedures.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_PROCEDURE_COST_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Estimator.GetGroupedProcedures.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}